import { ApiProvider } from "@src/store/ApiProvider";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { handlePasswordManagerUnauthorized } from "./passwordManagerUnauthorized";

export interface ICredentialHealth {
	total: number;
	active: number;
	inactive: number;
	notChecked: number;
	valid?: number;
	invalid?: number;
}

interface ICredentialStatisticsResponse {
	credentialHealth: ICredentialHealth;
}

export interface IGetCredentialStatisticsParams {
	companyId?: number | string;
}

const initialState: ICredentialHealth = {
	total: 0,
	active: 0,
	inactive: 0,
	notChecked: 0,
};

const credentialStatisticsPath = "/passwordManager/CredentialDashboard/StatisticsOverview";

const getExternalUrl = (params: IGetCredentialStatisticsParams) => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	const searchParams = new URLSearchParams();

	if (params.companyId !== undefined && params.companyId !== null && params.companyId !== "") {
		searchParams.set("companyId", String(params.companyId));
	}

	const query = searchParams.toString();
	const path = `${baseUrl.replace(/\/$/, "")}/CredentialDashboard/StatisticsOverview`;

	return query ? `${path}?${query}` : path;
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

export const { thunk: getCredentialStatistics, slice: credentialStatisticsSlice } = getThunkAndSlice<
	IGetCredentialStatisticsParams,
	ICredentialStatisticsResponse,
	ICredentialHealth
>({
	initialState,
	path: credentialStatisticsPath,
	externalPath: getExternalUrl,
	responsePath: "credentialHealth",
	getHeaders: getAuthHeaders,
	onUnauthorized: handlePasswordManagerUnauthorized,
});
